// ---------------------------------------------------------------------------
// Apollo industry tag IDs
//
// Apollo's `q_organization_keyword_tags[]` filter is fuzzy: a company is
// matched when the term appears anywhere in its keyword tags, which lets e.g.
// Microsoft ("manufacturing" is one of its 100+ keyword tags) slip through a
// Manufacturing industry filter. Apollo's STRUCTURED industry filter
// (`organization_industry_tag_ids[]`) matches only the company's single
// classified industry — far more precise.
//
// The tag IDs below were harvested empirically from Apollo's
// `organizations/search` responses (field `industry_tag_id`, 07/2026). They
// are stable public identifiers of Apollo's LinkedIn-style industry taxonomy.
// ---------------------------------------------------------------------------

/** Lowercased Apollo industry name → Apollo industry tag id. */
export const APOLLO_INDUSTRY_TAG_IDS: Record<string, string> = {
  accounting: '5567ce1f7369643b78570000',
  'airlines/aviation': '5567e0bf7369641d115f0200',
  'alternative medicine': '5567e27c7369642ade490000',
  animation: '5567e36f73696431a4970000',
  'apparel & fashion': '5567cd82736964540d0b0000',
  'architecture & planning': '5567cdb77369645401080000',
  automotive: '5567cdf27369644cfd800000',
  'aviation & aerospace': '5567e0dd73696416d3c20100',
  banking: '5567ce237369644ee5490000',
  biotechnology: '5567d08e7369645dbc4b0000',
  'building materials': '5567e1a17369641ea9d30100',
  'capital markets': '5567cdb773696439a9080000',
  chemicals: '5567e21e73696426a1030000',
  'civic & social organization': '5567cdda7369644eed130000',
  'civil engineering': '5567e13a73696418756e0200',
  'computer & network security': '5567cd877369644cf94b0000',
  'computer games': '5567cd8b736964540d0f0000',
  'computer hardware': '5567e0d47369641233eb0600',
  construction: '5567cd4773696439dd350000',
  'consumer goods': '5567ce987369643b789e0000',
  'consumer services': '5567d1127261697f2b1d0000',
  dairy: '5567e8a27369646ddb0b0000',
  'defense & space': '5567e1097369641b5f810500',
  design: '5567cdbc73696439d90b0000',
  'e-learning': '5567e19c7369641c48e70100',
  'education management': '5567ce9e736964540d540000',
  'electrical/electronic manufacturing': '5567cd4c73696439c9030000',
  entertainment: '5567cdd37369643b80510000',
  'environmental services': '5567ce5b736964540d280000',
  'events services': '5567cd8e7369645409450000',
  'executive office': '5567e09473696410dbf00700',
  'facilities services': '5567ce9c7369643bc9980000',
  farming: '5567cd4f7369644d2d010000',
  'financial services': '5567cdd67369643e64020000',
  fishery: '5567f96c7369642a22080000',
  'food & beverages': '5567ce1e7369643b806a0000',
  'food production': '5567e1b3736964208b280000',
  'fund-raising': '5567d2ad7261697f2b1f0100',
  furniture: '5567cede73696440d0040000',
  'gambling & casinos': '5567e0cf7369641233e50600',
  'glass, ceramics & concrete': '5567cd4f736964397e030000',
  'government administration': '5567cd527369643981050000',
  'government relations': '5567e29b736964256c370100',
  'graphic design': '5567cd4d73696439d9040000',
  'health, wellness & fitness': '5567cddb7369644d250c0000',
  'higher education': '5567cd4c73696453e1300000',
  'hospital & health care': '5567cdde73696439812c0000',
  hospitality: '5567ce9d7369643bc19c0000',
  'human resources': '5567e0e37369640e5ac10c00',
  'import & export': '5567ce9d7369645430c50000',
  'information services': '5567e0c97369640d2b3b1600',
  'information technology & services': '5567cd4773696439b10b0000',
  insurance: '5567cdd973696453d93f0000',
  'international affairs': '5567e3657369642f4ec90000',
  'international trade & development': '5567ce9c7369644eed680000',
  internet: '5567cd4d736964397e020000',
  'investment management': '5567e0bc7369641d11550200',
  'law enforcement': '5567e0e073696408da441e00',
  'law practice': '5567ce1f7369644d391c0000',
  'legal services': '5567ce2d7369644d25250000',
  'legislative office': '5567e1797369641c48c10100',
  'leisure, travel & tourism': '5567cdd87369643bc12f0000',
  'logistics & supply chain': '5567cd4973696439b9010000',
  'luxury goods & jewelry': '5567cda97369644cfd3e0000',
  machinery: '5567cd4973696439d53c0000',
  'management consulting': '5567cdd47369643dbf260000',
  maritime: '5567cd8273696439b1240000',
  'market research': '5567e1387369641ec75d0200',
  'marketing & advertising': '5567cd467369644d39040000',
  'mechanical or industrial engineering': '5567ce2673696453d95c0000',
  'media production': '5567e0ea7369640d2ba31600',
  'medical devices': '5567e1b97369641ea9690200',
  'medical practice': '5567d0467369645dbc200000',
  'mental health care': '5567ce2773696454308f0000',
  military: '5567e2c572616932bb3b0000',
  'mining & metals': '5567e3f3736964395d7a0000',
  'museums & institutions': '5567e15373696422aa0a0000',
  music: '5567cd4f736964540d050000',
  nanotechnology: '5567e7be736964110e210000',
  'nonprofit organization management': '5567cd4773696454303a0000',
  'oil & energy': '5567cdd97369645624020000',
  'online media': '5567cdb373696439dd540000',
  'outsourcing/offshoring': '5567d04173696457ee520000',
  'package/freight delivery': '5567e8bb7369641a658f0000',
  'packaging & containers': '5567e36973696431a4480000',
  'paper & forest products': '5567e97f7369641e57730100',
  'performing arts': '5567e0af7369641ec7300000',
  pharmaceuticals: '5567e0eb73696410e4bd1200',
  photography: '5567cd4f7369644cfd250000',
  plastics: '5567cdda7369644cf95d0000',
  'political organization': '5567e25f736964256cff0000',
  'primary/secondary education': '5567cdd97369645430680000',
  'professional training & coaching': '5567cd49736964541d010000',
  'program development': '5567e2907369642433e60200',
  'public policy': '5567e28a7369642ae2500000',
  'public relations & communications': '5567ce5973696453d9780000',
  'public safety': '5567cd4a7369643ba9010000',
  publishing: '5567ce5b73696439a17a0000',
  ranching: '5567fd5a73696442b0f20000',
  'real estate': '5567cd477369645401010000',
  'recreational facilities & services': '5567e134736964214f5e0000',
  'religious institutions': '5567e0f27369640e5aed0c00',
  'renewables & environment': '5567cd49736964540d020000',
  research: '5567e09f736964160ebb0100',
  restaurants: '5567e0e0736964198de70700',
  retail: '5567ced173696450cb580000',
  'security & investigations': '5567e19b7369641ead740000',
  semiconductors: '5567e0d87369640e5aa30c00',
  shipbuilding: '5568047d7369646d406c0000',
  'sporting goods': '5567e113736964198d5e0800',
  sports: '5567ce227369644eed290000',
  'staffing & recruiting': '5567e09973696410db020800',
  telecommunications: '5567cd4c7369644d39080000',
  textiles: '5567e1327369641d91ce0300',
  'think tanks': '5567e1de7369642069ea0100',
  tobacco: '55680085736964551e070000',
  'translation & localization': '5567e1097369641d91230300',
  'transportation/trucking/railroad': '5567cd4e7369644cf93b0000',
  utilities: '5567e2127369642420170000',
  'venture capital & private equity': '5567e1587369641c48370000',
  veterinary: '5567ce9673696439d5c10000',
  wholesale: '5567d01e73696457ee100000',
  'wine & spirits': '5567cd4d7369643b78100000',
  'writing & editing': '5567cdd973696439a1370000',
};

/**
 * Umbrella terms (UI dropdown labels + common ICP wording) → the set of Apollo
 * industry names they cover. Apollo's taxonomy has no generic "manufacturing"
 * industry — only subsectors — so umbrella terms expand to the matching set.
 * Keys are lowercased.
 */
const UMBRELLA_INDUSTRIES: Record<string, string[]> = {
  manufacturing: [
    'machinery',
    'electrical/electronic manufacturing',
    'mechanical or industrial engineering',
    'plastics',
    'chemicals',
    'packaging & containers',
    'paper & forest products',
    'textiles',
    'food production',
    'glass, ceramics & concrete',
    'building materials',
    'automotive',
    'aviation & aerospace',
    'shipbuilding',
    'mining & metals',
    'semiconductors',
    'furniture',
    'apparel & fashion',
    'dairy',
  ],
  'aerospace & defense': ['aviation & aerospace', 'defense & space'],
  'accounting services': ['accounting'],
  'advertising & marketing': ['marketing & advertising'],
  advertising: ['marketing & advertising'],
  'colleges & universities': ['higher education'],
  cybersecurity: ['computer & network security'],
  education: ['education management', 'higher education', 'primary/secondary education', 'e-learning'],
  government: ['government administration'],
  'healthcare services': ['hospital & health care', 'medical practice', 'health, wellness & fitness'],
  healthcare: ['hospital & health care', 'medical practice', 'health, wellness & fitness'],
  'hospitals & physicians clinics': ['hospital & health care', 'medical practice'],
  'industrial automation': ['machinery', 'mechanical or industrial engineering'],
  'investment banking': ['investment management', 'capital markets', 'banking'],
  'k-12 schools': ['primary/secondary education'],
  'law firms & legal services': ['law practice', 'legal services'],
  legal: ['law practice', 'legal services'],
  logistics: ['logistics & supply chain', 'package/freight delivery'],
  'media & internet': ['online media', 'media production', 'internet', 'publishing'],
  'non-profit': ['nonprofit organization management'],
  nonprofit: ['nonprofit organization management'],
  'renewable energy': ['renewables & environment'],
  'security products & services': ['security & investigations'],
  software: ['information technology & services', 'internet'],
  technology: ['information technology & services', 'internet', 'computer hardware'],
  tech: ['information technology & services', 'internet', 'computer hardware'],
  training: ['professional training & coaching'],
  transportation: ['transportation/trucking/railroad', 'logistics & supply chain', 'package/freight delivery'],
  finance: ['financial services', 'banking', 'investment management'],
};

export interface IndustryTagResolution {
  /** Apollo industry tag ids for all resolved labels. */
  tagIds: string[];
  /** Labels that could not be resolved to a structured tag id. */
  unresolved: string[];
}

const tokenize = (value: string): string[] =>
  value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

// "retailer" ≠ "retail", but "tag"/"tags" should match — allow a trailing s.
const tokensMatch = (a: string, b: string): boolean => a === b || a === `${b}s` || b === `${a}s`;

const isTokenSubset = (needle: string[], haystack: string[]): boolean =>
  needle.length > 0 && needle.every(n => haystack.some(h => tokensMatch(n, h)));

/**
 * Token-level fallback for labels without an exact entry: a label matches a
 * known industry when one's tokens are a subset of the other's. Covers the two
 * common miss patterns of LLM-extracted keywords —
 *   more specific than the taxonomy: "secondary education" ⊂ "primary/secondary education"
 *   wrapped in filler words:        "software companies" ⊃ umbrella "software"
 * Exact Apollo industry names are tried before umbrella terms so a precise
 * label ("secondary education") is not widened to a whole umbrella set.
 */
const fuzzyResolveLabel = (label: string): string[] => {
  const labelTokens = tokenize(label);
  const directIds = new Set<string>();
  for (const [name, id] of Object.entries(APOLLO_INDUSTRY_TAG_IDS)) {
    const nameTokens = tokenize(name);
    if (isTokenSubset(labelTokens, nameTokens) || isTokenSubset(nameTokens, labelTokens)) directIds.add(id);
  }
  if (directIds.size > 0) return [...directIds];
  const umbrellaIds = new Set<string>();
  for (const [term, names] of Object.entries(UMBRELLA_INDUSTRIES)) {
    const termTokens = tokenize(term);
    if (!isTokenSubset(labelTokens, termTokens) && !isTokenSubset(termTokens, labelTokens)) continue;
    for (const name of names) {
      const id = APOLLO_INDUSTRY_TAG_IDS[name];
      if (id) umbrellaIds.add(id);
    }
  }
  return [...umbrellaIds];
};

/**
 * Resolve human-readable industry labels (UI dropdown values, LLM-extracted
 * keywords) to Apollo industry tag ids. A label resolves when it names an
 * Apollo industry directly or matches an umbrella term. Unresolvable labels
 * (niche business types like "kitchen studio") are returned separately so the
 * caller can fall back to keyword-tag filtering for them.
 */
export const resolveIndustryTagIds = (labels: string[]): IndustryTagResolution => {
  const tagIds = new Set<string>();
  const unresolved: string[] = [];
  for (const raw of labels) {
    const label = raw.trim().toLowerCase();
    if (!label) continue;
    const umbrella = UMBRELLA_INDUSTRIES[label];
    if (umbrella) {
      for (const name of umbrella) {
        const id = APOLLO_INDUSTRY_TAG_IDS[name];
        if (id) tagIds.add(id);
      }
      continue;
    }
    const direct = APOLLO_INDUSTRY_TAG_IDS[label];
    if (direct) {
      tagIds.add(direct);
      continue;
    }
    const fuzzy = fuzzyResolveLabel(label);
    if (fuzzy.length > 0) {
      for (const id of fuzzy) tagIds.add(id);
      continue;
    }
    unresolved.push(raw.trim());
  }
  return { tagIds: [...tagIds], unresolved };
};
